import { create } from 'zustand';

/** Структурированные тех. детали ошибки — не редактируемые пользователем */
export interface ErrorMetadata {
  errorId?: string;
  timestamp?: string;
  page?: string;
  url?: string;
  tableTitle?: string;
  httpStatus?: number;
  correlationId?: string;
  operationId?: string;
  errorMessage?: string;
  stack?: string;
  browser?: string;
  screenSize?: string;
}

export interface ErrorContext {
  subcategoryId?: string;
  title?: string;
  description?: string;
  metadata?: ErrorMetadata;
}

interface SupportModalState {
  isOpen: boolean;
  errorContext: ErrorContext | null;
  openWithError: (ctx: ErrorContext) => void;
  openClean: () => void;
  close: () => void;
}

export const useSupportModalStore = create<SupportModalState>((set) => ({
  isOpen: false,
  errorContext: null,

  openWithError: (ctx) => set({ isOpen: true, errorContext: ctx }),
  openClean: () => set({ isOpen: true, errorContext: null }),
  close: () => set({ isOpen: false, errorContext: null }),
}));
